import { api, unwrap } from './client';
import type { components } from '../types/learnerApi';

type LearnerProgress = components['schemas']['LearnerProgress'];
type ItemAnswerRequest = components['schemas']['ItemAnswerRequest'];
type FeedbackRecord = components['schemas']['FeedbackRecord'];
type FeedbackSubmitRequest = components['schemas']['FeedbackSubmitRequest'];

export async function startAttempt(assignmentId: string, moduleId: string): Promise<LearnerProgress> {
  const res = await api.post(`/me/courses/${assignmentId}/modules/${moduleId}/attempts`, {});
  return unwrap(res);
}

export async function getCurrentAttempt(assignmentId: string, moduleId: string): Promise<LearnerProgress> {
  const res = await api.get(`/me/courses/${assignmentId}/modules/${moduleId}/attempts/current`);
  return unwrap(res);
}

export async function submitItemAnswer(
  assignmentId: string,
  moduleId: string,
  payload: ItemAnswerRequest
): Promise<LearnerProgress> {
  const res = await api.patch(
    `/me/courses/${assignmentId}/modules/${moduleId}/attempts/current`,
    payload
  );
  return unwrap(res);
}

export async function finalizeAttempt(assignmentId: string, moduleId: string): Promise<LearnerProgress> {
  const res = await api.post(
    `/me/courses/${assignmentId}/modules/${moduleId}/attempts/current/finalize`
  );
  return unwrap(res);
}

export async function getFeedback(assignmentId: string, moduleId: string): Promise<FeedbackRecord> {
  const res = await api.get(`/me/courses/${assignmentId}/modules/${moduleId}/feedback`);
  return unwrap(res);
}

export async function submitFeedback(
  assignmentId: string,
  moduleId: string,
  payload: FeedbackSubmitRequest
): Promise<FeedbackRecord> {
  const res = await api.post(
    `/me/courses/${assignmentId}/modules/${moduleId}/feedback`,
    payload
  );
  return unwrap(res);
}
